import { createSelector } from 'reselect';

import { GridSourceParams } from '../typings/grid';

import { selectGridSourceParams } from './gridSourceParams/gridSourceParams';

export const selectGridSourceParamsViewForRum = createSelector(
    selectGridSourceParams,
    (sourceParams?: GridSourceParams) =>
        sourceParams ? sourceParams.view : undefined
);
